const GuernseySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111549)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.8307 17.3913H22.6088H22.6087V0.169297C21.7548 0.058125 20.8841 0 20 0C19.1159 0 18.2452 0.058125 17.3913 0.169297V17.3913H0.169297C0.058125 18.2452 0 19.1159 0 20C0 20.8841 0.058125 21.7548 0.169297 22.6087H17.3912H17.3913V39.8307C18.2452 39.9419 19.1159 40 20 40C20.8841 40 21.7548 39.942 22.6087 39.8307V22.6089V22.6087H39.8307C39.9419 21.7548 40 20.8841 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913Z"
        fill="#D80027"
      />
      <path
        d="M25.6521 20.869L26.9564 21.7386V18.2603L25.6521 19.1299H20.8695V14.3473L21.7391 13.043H18.2608L19.1304 14.3473V19.1299H14.3478L13.0435 18.2603V21.7386L14.3478 20.869H19.1304V25.6516L18.2608 26.9559H21.7391L20.8695 25.6516V20.869H25.6521Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111549">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GuernseySvg;
